import React, { useEffect, useState } from 'react';
import ReactJson from 'react-json-view';

interface DataItem {
  id: number;
  name: string;
}

const JsonViewerTwo: React.FC = () => {
  const [data, setData] = useState<DataItem[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [offset, setOffset] = useState(0);
  const [hasMoreData, setHasMoreData] = useState(true);
  const [requestCount, setRequestCount] = useState(1);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`https://viewer-json-api-558926418263.us-central1.run.app/data?offset=${offset}&limit=${62500 * requestCount}`);

        if (!response.body) {
          throw new Error('ReadableStream not yet supported in this browser.');
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder('utf-8');
        let jsonString = '';

        const readStream = async () => {
          while (true) {
            const { done, value } = await reader.read();
            if (done) {
              setHasMoreData(false);
              break;
            }

            jsonString += decoder.decode(value, { stream: true });
            const lines = jsonString.split('\n');
            jsonString = lines.pop() || '';

            for (const line of lines) {
              if (line.trim()) {
                setData((prevData) => [...prevData, JSON.parse(line)]);
              }
            }
          }
        };

        readStream().catch((err) => setError(err.message));
      } catch (err: any) {
        setError(err.message);
      }
    };

    fetchData();
  }, [offset, requestCount]);

  const handleLoadMore = () => {
    setRequestCount((prevCount) => prevCount + 1);
  };

  return (
    <div>
      <h1>JSON Data Viewer</h1>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      <ReactJson src={data} collapsed={true} enableClipboard={true} displayDataTypes={false} />
        <button onClick={handleLoadMore}>Load More Data</button>
    </div>
  );
};

export default JsonViewerTwo;